export default function getEnvFromUrl(location: Location) {
  if (location.hostname === 'help.sumup.com') {
    return 'production';
  }
  if (location.hostname === 'support-centre.sam-app.ro') {
    return 'staging';
  }
  return 'development';
}
